import baseStyled, {
  css as baseCss,
  ThemedCssFunction,
  ThemedStyledInterface,
  useTheme as baseUseTheme,
} from 'styled-components';
import { Tokens } from '../types';

export type themeType = typeof Tokens.eixods;

export const styled = baseStyled as ThemedStyledInterface<themeType>;

export const css = baseCss as ThemedCssFunction<themeType>;

export const useTheme = baseUseTheme as () => themeType;
